import { render, staticRenderFns } from "./index_v1.0.vue?vue&type=template&id=59020c50&scoped=true&"
import script from "./index_v1.0.vue?vue&type=script&lang=js&"
export * from "./index_v1.0.vue?vue&type=script&lang=js&"
import style0 from "./index_v1.0.vue?vue&type=style&index=0&id=59020c50&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59020c50",
  null
  
)

export default component.exports